import { IQuestion } from '../properties/assessment';

const TextQuestion = ({ question, name, value, onChange }: {
    question: IQuestion,
    name: string,
    value: string,
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur: () => void;
}) => {

    return (
        <div className="form-group">
            <textarea
                className="form-control form-control-sm"
                name={name}
                value={value}
                onChange={onChange}
            />
        </div>
    )
};

export default TextQuestion;
